import type { PersonalUsePolicy } from "../../shared/personalUse";
import { SettingsCard, SettingsHeading, SettingsRow } from "./SettingsCard";
import { Text } from "./Text";
import { Toggle } from "./Toggle";

type Props = {
  resourceLabel: string;
  personalUse: PersonalUsePolicy | null;
  canManage: boolean;
  onChange: (personalUse: PersonalUsePolicy) => void;
};

export function PersonalUseCard({
  resourceLabel,
  personalUse,
  canManage,
  onChange,
}: Props) {
  const isOn = personalUse !== "disabled";
  return (
    <SettingsCard>
      <SettingsRow>
        <SettingsHeading>
          <Text variant="text-regular-md">Personal use</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            Let people with access use this {resourceLabel} in their personal
            workflows and personal chats.
          </Text>
        </SettingsHeading>
        <Toggle
          isOn={isOn}
          disabled={!canManage}
          onToggle={() => onChange(isOn ? "disabled" : "enabled")}
        />
      </SettingsRow>
    </SettingsCard>
  );
}
